import { PropsWithChildren } from 'react';

import { ChakraFlex } from '@equip.health/ui';

const TOP_LEVEL_ID = 'notification-detail-wrapper';

const NotificationDetailWrapper = ({ children }: PropsWithChildren) => {
  return (
    <ChakraFlex
      alignItems="center"
      backgroundColor="neutral.background.secondary"
      borderRadius="8px"
      flexWrap="wrap"
      id={`${TOP_LEVEL_ID}`}
      marginRight="8px"
      padding="8px"
    >
      {children}
    </ChakraFlex>
  );
};

export default NotificationDetailWrapper;
